module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAHhJREFUKFNjZCARMJKonoE6GkRj/peDbH69hLET3QUYNoAVMzKkgBX+Z5iDrglFA0zx338MjiD1zEwM+9E1wTUgK363lPEJSINQ9H8ZdE1gDQIB/wVYeRjW//3PEAtTDHM7WBMjw+LfXxgCP2xg/ECdUMIXN7S3AQCk5y4NR7hrcAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images2/down_active.png
// module id = aWHw
// module chunks = 2